import { searchBin } from '../data/searchData';
class SearchPages {
	private root: { [key: string]: Record<number, any> } = {};
	has = (key: string, prefix: string) => {
		const cleanPrefix = prefix.trim().toLocaleUpperCase();
		if (!Object.hasOwn(this.root, key)) { return false; }
		let current = this.root[key];
		for (let i = 0; i < cleanPrefix.length; i++) {
			const code = cleanPrefix.charCodeAt(i);
			if (!Object.hasOwn(current, code)) {
				return false;
			}
			current = current[code];
		}
		return true;
	}

	constructor () {
		const binaryString = atob(searchBin);
		const bytes = Uint8Array.from(binaryString, (char: string) => char.charCodeAt(0));
		this.root = JSON.parse(new TextDecoder().decode(bytes));
	}
}

export { SearchPages }